module.exports = __webpack_public_path__ + "img/logo.533e188.svg";